module.exports = __webpack_public_path__ + "static/img/40016 (3).5ebed26.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40016 (3).webp
// module id = 7Ks2
// module chunks = 14